import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=e8451152"
import script from "./EditLink.vue?vue&type=script&lang=js"
export * from "./EditLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports